import { useAuth } from '../contexts/AuthContext';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount } from 'wagmi';
import { useEffect, useState } from 'react';

const LoginButton = ({ size = 'large' }) => {
  const { login, isLoading, isAuthenticated } = useAuth();
  const { open } = useWeb3Modal();
  const { isConnected } = useAccount();
  const [pendingLogin, setPendingLogin] = useState(false);

  // Auto-login after wallet connection
  useEffect(() => {
    if (isConnected && pendingLogin && !isAuthenticated) {
      setPendingLogin(false);
      login().catch(() => {
        // Error handled in context
      });
    }
  }, [isConnected, pendingLogin, isAuthenticated, login]);

  const handleLogin = async () => {
    try {
      if (!isConnected) {
        // Open wallet connect modal
        setPendingLogin(true);
        await open();
      } else {
        // Already connected, just login
        await login();
      }
    } catch (err) {
      setPendingLogin(false);
      // Error is already handled in context
    }
  };

  if (size === 'small') {
    return (
      <div className="relative">
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-3 py-2 rounded-md font-medium text-sm transition-colors duration-200 flex items-center gap-1.5 whitespace-nowrap"
        >
          {isLoading ? (
            <>
              <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <span className="hidden sm:inline">Connecting...</span>
              <span className="sm:hidden">...</span>
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
              <span className="hidden md:inline">Sign In with Ethereum</span>
              <span className="md:hidden">Sign In</span>
            </>
          )}
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <button
        onClick={handleLogin}
        disabled={isLoading}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-8 py-3 rounded-lg font-semibold text-lg transition-colors duration-200 flex items-center gap-2"
      >
        {isLoading ? (
          <>
            <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            Connecting...
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
            Sign In with Ethereum
          </>
        )}
      </button>

      <div className="text-sm text-gray-500 text-center max-w-md">
        Connect your wallet to access the ZPayNow platform
      </div>
    </div>
  );
};

export default LoginButton;